import styled from '@emotion/styled';

const ReleaseSummary = styled('p')(({ theme }) => ({
  margin: 0,
  color: theme.palette.text.secondary,
  fontSize: 15,
}));

export default ReleaseSummary;
